import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=0b2cb0dd&scoped=true&"
import script from "./AppAside.vue?vue&type=script&lang=js&"
export * from "./AppAside.vue?vue&type=script&lang=js&"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=0b2cb0dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2cb0dd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Typography: require('/opt/build/repo/components/Typography.vue').default,UiImage: require('/opt/build/repo/components/UiImage.vue').default})
